import { message, Switch } from "antd";
import React, { useState } from "react";
import { IClient } from "../../pages/Clients";
import { api } from "../../services/api";
import { Input } from "../Input";
import { Modal } from "../Modal";
import { Content } from "./styles";

interface Props {
  client: IClient;
  title: string;
  confirm: (client: IClient)=> void;
  cancel: ()=> void;
}
export function EditClientModal({client, title, confirm, cancel,...rest}: Props) {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(client.name);
  const [corporateName, setCorporateName] = useState(client.corporateName);
  const [email, setEmail] = useState(client.email);
  const [cpfCnpj, setCpfcnpj] = useState(client.cpfCnpj);
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState(!client.isBlocked);
  function update(client: IClient) {
    setLoading(true)
    api.put('clients',  client).then(()=>{
      message.success('Cliente atualizado com sucesso!');
      confirm(client)
    }).catch((e)=>{
      message.error(e.response.data.message)
    }).finally(()=> setLoading(false));
  }
  function handleEditClient() {
    if(!name || !email){
      return message.info('Preencha todos os dados marcados com *');
    }
    update({
      ...client,
      cpfCnpj,
      name,
      email,
      password,
      isBlocked: !status,
      corporateName,
    })
  }
  return(
    <Modal
          cancel={cancel}
          confirm={handleEditClient}
          loading={loading}
          title={title}
          btnTitle="Editar"
        >
          <Content>
            <div className="form-group">
              <span>*Nome:</span>
              <Input placeholder="Digite um nome"   value={name}
                onChange={(ev) => setName(ev.currentTarget.value)} />
            </div>
            <div className="form-group">
              <span>Nome Corporativo:</span>
              <Input placeholder="Digite um nome corporativo"   value={corporateName}
                onChange={(ev) => setCorporateName(ev.currentTarget.value)}/>
            </div>
            <div className="form-group">
              <span>*Email:</span>
              <Input placeholder="Digite um email"   value={email}
                onChange={(ev) => setEmail(ev.currentTarget.value)} />
            </div>
            <div className="form-group">
              <span>CPF/CNPJ:</span>
              <Input placeholder="Digite um CPF ou CNPJ"    value={cpfCnpj}
                onChange={(ev) => setCpfcnpj(ev.currentTarget.value)}/>
            </div>
            <div className="form-group">
              <span>Senha:</span>
              <Input placeholder="Digite uma senha"   value={password}
              type='password'
                onChange={(ev) => setPassword(ev.currentTarget.value)}/>
            </div>
            <div className="form-group">
              <span>Status:</span>
              <Switch
                checkedChildren="ATIVO"
                unCheckedChildren="INATIVO"
                defaultChecked={status}
                checked={status}
                onChange={(ev)=>{setStatus(ev)}}
                style={{ borderRadius: "8px" }}
              />
            </div>
          </Content>
        </Modal>
      
  )
}
